import { render, staticRenderFns } from "./deposit-review.vue?vue&type=template&id=e48cb382&"
import script from "./deposit-review.vue?vue&type=script&lang=js&"
export * from "./deposit-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports